import React, { useState } from 'react';
import { useTeam } from './TeamContext';

const Episode1_2 = () => {
  const { team, saveTeamDetails } = useTeam();
  const [newDrawioUrl, setNewDrawioUrl] = useState(team.drawio_url || '');

  const handleSubmit = () => {
    //const episodes_unlocked = team.episodes_unlocked || []
    //const episode_id = 1.2
    //const updatedEpisodes = episodes_unlocked.includes(episode_id)
    //  ? episodes_unlocked
    //  : [...episodes_unlocked, episode_id].sort((a, b) => a - b);

    const updatedTeam = {
      ...team,
      //episodes_unlocked: updatedEpisodes,
      drawio_url: newDrawioUrl
    };

    saveTeamDetails(updatedTeam);
  };

  return (
    <div>
      <div>
        <h3 className="font-lustra text-3xl text-white text-center mt-12 mb-6">
          Episodio 1.2: El Caos Sincronizado
        </h3>
        <div className="mt-2 mb-2 text-lg space-y-4 text-white">
          <p>
            Como todo servicio de clase galáctica, nuestro procesador de pagos <span className="font-bold">BigBang</span> no
            está exento de "pequeños" contratiempos. Ya saben, cosas menores como agujeros negros que distorsionan
            el espacio-tiempo, ondas electromagnéticas provenientes de supernovas cercanas, y, claro, el clásico deploy
            de código un Viernes a la tarde (porque si no es Viernes, ¿cuándo?).
          </p>
          <p>
            Pero no teman, porque nuestros brillantes ingenieros -que definitivamente no improvisaron esto bajo presión-
            han implementado sofisticados mecanismos de comunicación asincrónica. En otras palabras, cuando un pago no puede procesarse
            al instante (por razones cósmicas fuera de nuestro control), lo dejamos en una queue intergaláctica para asegurarnos
            de que eventualmente llegue a su destino. ¡Es como magia, pero con más logs y menos conjuros!
          </p>
          <p>
            Gracias a este sistema, aunque un rayo gamma interrumpa la transacción, podemos garantizar que tu pago no se perderá.
            Solo tomará un poco más de tiempo, probablemente el tiempo estándar de un par de órbitas estelares, o tal vez menos
            si los astros se alinean a nuestro favor.
          </p>
          <p>
            "¡Sincronía, para qué te quiero?!" pensarán algunos... pero la solución no está en las estrellas,
            sino en el cuerpo del mensaje que nos envían. La clave es agregar un simple
            campo <span className="bg-gray-100 text-red-600 font-mono px-1 rounded">"notification_url": "$url"</span> al body,
            durante el llamado a nuestra API. Con esta misteriosa URL, <span className="font-bold">BigBang</span> promete
            (con los dedos cruzados, claro) devolver una respuesta en algún momento del futuro, una vez que
            pueda procesar el pago exitosamente.
          </p>
          <p>
            Porque en <span className="font-bold">BigBang</span>, sabemos que los pagos intergalácticos no
            siempre son instantáneos, pero con comunicación asincrónica, al menos siempre son posibles. 🚀
          </p>
          <p className="mt-6">
            Y así, intrépidos jugadores, hemos llegado al momento cumbre del episodio: no basta con tener la
            URL correcta, necesitamos entender <b>cómo planean domar este caos intergaláctico</b>.
          </p>
          <p>
            Deberán compartirnos el diagrama de arquitectura de su solución. Algo claro, brillante y
            tan bien organizado que hasta un droide averiado podría entenderlo.
          </p>
          <p>
            Porque, como dice el viejo refrán galáctico:
            <i><b>"Una imagen vale más que mil líneas de logs."</b></i>
          </p>
          <p>
            Pero cuidado:
          </p>
          <p>
          <div>
            <ul className="list-disc pl-8 space-y-2">
              <li className="text-gray-200">
                <span className="font-bold">Diagramas mal hechos pueden enviar señales de confusión a
                  otras galaxias.
                </span>
                Y nadie quiere que un planeta vecino copie su desorden.
              </li>
              <li className="text-gray-200">
                <span className="font-bold">Si su arquitectura tiene más flechas que sentido</span>, quizás
                sea momento de replantear la estrategia antes de que los mensajes empiecen a perderse en algún
                limbo estelar.
              </li>
              <li className="text-gray-200">
                <span className="font-bold">Si logran algo visualmente impecable</span>, prometemos (con los
                dedos cruzados) evaluarlo sin juzgar demasiado sus anotaciones apuradas.
              </li>
            </ul>
          </div>
          </p>
          <p>
            El objetivo es simple: <b>mostrar cómo su nave intergaláctica procesa los pagos, maneja las respuestas,
            y evita colisiones con el caos asincrónico.</b> Si la solución no está en las estrellas, al menos que
            esté en un esquema que podamos admirar.
          </p>
          <p>
            Así que adelante, ingenieros de la galaxia: envíen su diagrama y demuestren que están listos para
            enfrentarse al próximo episodio. Porque si una imagen dice más que mil palabras, <b>un buen diagrama
            puede salvarlos de mil problemas</b>.
          </p>
          <p>
            ¡Nos vemos en el siguiente salto al hiperespacio! 🚀
          </p>
        </div>

        <div className="mt-2 mb-2 text-lg space-y-4 text-white">
          <div className="mt-4 border-t border-gray-100">
            <div className="mt-4 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
              <div className="sm:col-span-6">
                <label htmlFor="drawio_url" className="block text-lg font-bold leading-6 text-white">
                Draw.io link al diagrama de arquitectura
                </label>
                <div className="mt-2">
                  <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-600 sm:max-w-full">
                    <input
                      id="drawio_url"
                      name="drawio_url"
                      type="text"
                      value={newDrawioUrl}
                      onChange={(e) => setNewDrawioUrl(e.target.value)}
                      className="block flex-1 border-0 bg-transparent py-1.5 pl-1 text-white placeholder:text-gray-400 focus:ring-0 sm:text-base sm:leading-6"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-6 flex items-center gap-x-6 justify-end">
            <button
              onClick={handleSubmit}
              className="rounded-md bg-blue-700 px-3 py-2 text-lg font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Siguiente!
            </button>
          </div>
        </div>

      </div>

    </div>
  );
};

export default Episode1_2;

